import { useIsTenantAdmin } from "@visioni/a3s-access/app";
import { useTenantFeatures } from "@src/features/tenants";
import {
  resolveReportEntitlements,
  type ReportEntitlements,
  type ReportViewer,
} from "@src/features/reports/entitlements";
import { FEATURE_FLAGS, useBooleanFlag } from "@src/services/feature-flags/feature-flags";

/**
 * The report tiles this user is entitled to, projected from what the cameras
 * they can see are hired for. Costs no request of this page's own - see
 * {@link useTenantFeatures}.
 */
export function useReportEntitlements(): ReportEntitlements {
  const features = useTenantFeatures();
  const cameraScoped = useBooleanFlag(FEATURE_FLAGS.ROADSENSE_CAMERA_ACCESS);
  const { isTenantAdmin, isLoading } = useIsTenantAdmin();
  const viewer: ReportViewer =
    cameraScoped ? { access: "camera", isTenantAdmin: isLoading ? undefined : isTenantAdmin } : { access: "tenant" };
  return resolveReportEntitlements(features, viewer);
}
